import React from "react";
import { LoanTable } from "./LoanTable";

const Expected = (r) => r.attorney_current_firm_id
  ? <span className="text-[10px]">attorney's firm now: <b>{r.attorney_current_firm_name || "—"}</b> <span className="font-mono">{r.attorney_current_firm_id}</span></span>
  : <span className="text-[10px] text-[#9CA3AF]">attorney has no firm on file</span>;

export const FirmHygienePanel = ({ hygiene }) => (
  <div className="space-y-5" data-testid="firm-hygiene-panel">
    <div className="p-4 rounded-xl border border-[#E5E7EB] bg-white text-sm text-[#374151]">
      <div className="font-semibold text-[#0A2540]">Tier 3: firm_id reconciliation (report only)</div>
      <p className="mt-1">This tool never fills in or changes a firm_id. Fix firm assignments yourself on each loan record. Loans without a firm_id don't appear in any attorney portal, even after their client group is merged.</p>
    </div>
    <div>
      <div className="font-semibold text-sm text-[#0A2540] mb-2" data-testid="missing-firm-count">Missing firm_id ({hygiene.missing_firm_id_count})</div>
      {hygiene.missing_firm_id.length ? <LoanTable rows={hygiene.missing_firm_id} testid="missing-firm-table" extraCol={Expected} />
        : <div className="text-sm text-[#6B7280]">None.</div>}
    </div>
    <div>
      <div className="font-semibold text-sm text-[#0A2540] mb-2" data-testid="mismatched-firm-count">firm_id differs from the attorney's current firm ({hygiene.mismatched_firm_id_count})</div>
      {hygiene.mismatched_firm_id.length ? <LoanTable rows={hygiene.mismatched_firm_id} testid="mismatched-firm-table" extraCol={Expected} />
        : <div className="text-sm text-[#6B7280]">None.</div>}
    </div>
  </div>
);
